import { Tooltip } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

interface ShowTextOnHoverProps {
  title: any;
  children: any;
}

const ShowTextOnHover = ({ title, children }: ShowTextOnHoverProps) => {
  return (
    <Wrapper>
      <Tooltip title={title} arrow placement="top">
        <div>{children}</div>
      </Tooltip>
    </Wrapper>
  );
};

export default ShowTextOnHover;
